<script lang="ts" setup>
// @ts-nocheck - Property 'index' does not exist on type '{ $: ComponentInternalInstance; $data: {}; $props: Partial<{}> & Omit<Readonly<ExtractPropTypes<__VLS_TypePropsToRuntimeProps<PagebuilderAccordionProps>>> & VNodeProps & AllowedComponentProps & ComponentCustomProps, never>; ... 10 more ...; $watch<T extends string | ((...args: any) => any)>(source: T, cb: T extends ...'.
// @ts-ignore
import { SplideSlide } from '@splidejs/vue-splide'
import { Bestsellers } from '~~/server/api/homepage'

import type { TabLink } from '~/components/tabs/Tabs.vue'

export interface WidgetBestsellersProps {
    data: Bestsellers
    headingLevel: HeadingLevel
}

const props = defineProps<WidgetBestsellersProps>()
const activeCategoryIndex = ref<number>(0)

const handleTabClick = (index: number): void => {
    activeCategoryIndex.value = index
}

const categories = computed<TabLink[]>((): TabLink[] =>
    props.data.data.map((category): TabLink => {
        return {
            name: category.title,
            icon: category.icon.path,
        }
    })
)
</script>

<template>
  <div
    class="rounded bg-gray-3 px-2 py-10 px-lg-6 py-lg-15"
    data-cy="best_sellers"
  >
    <Tracker :data="{ position: props.data.title }">
      <BoxHeader
        :heading="props.data.title"
        :heading-level="props.headingLevel"
      >
        <template #tag>
          <Tag
            class="text-uppercase"
            :decor="false"
            size="small"
            background-color="gray-1"
          >
            {{ props.data.tag }}
          </Tag>
        </template>
      </BoxHeader>
      <Tabs
        :links="categories"
        tabs-id="WidgetBestsellers"
        type="quarternary"
        is-slider
        @click="handleTabClick"
      >
        <template
          v-for="(category, index) in props.data.data"
          :key="index"
          #[`tab-panel-${index}`]
        >
          <Slider
            v-if="category.products.length > 0"
            class="widget-bestsellers-tab-slider positon-relative start-50 ps-6 ps-md-0 translate-middle-x"
          >
            <SplideSlide
              v-for="(product, productIndex) in category.products"
              :key="`product-box-${productIndex}`"
              class="mt-6 mt-md-3"
            >
              <ProductBox
                class="h-100"
                :item="product"
                heading-level="h3"
              />
            </SplideSlide>
          </Slider>
          <div class="d-flex justify-content-center mt-6">
            <VButton
              :to="{
                name: 'insurance-category-detail',
                params: {
                  id: category.slug,
                },
              }"
              :label="$t('Zobraziť všetky produkty')"
              size="large"
              color="link"
              class="fw-bold"
            >
              {{ $t('Zobraziť všetky produkty') }}
              <svg
                aria-hidden="true"
                class="insurance-additional-icon ms-1 transition"
                width="12"
                height="9"
              >
                <use xlink:href="#angle-right" />
              </svg>
            </VButton>
          </div>
        </template>
      </Tabs>
    </Tracker>
  </div>
</template>

<style>
@import './WidgetBestsellers.vars.scss';
</style>

<style lang="scss" scoped>
@import './WidgetBestsellers.scss';
</style>
